exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---10FY5:not(:first-child){margin-left:2rem}.timeSigBottom---vP3OE{margin-left:-2rem}.division---3lT_X{width:4rem!important}.label---2_7Tx{margin-right:1rem}.input---1T_FF{width:3rem;height:2.2rem}.divider---2x2l0{margin:0 .5rem;display:inline-block}", ""]);

// Exports
exports.locals = {
	"root": "root---10FY5",
	"timeSigBottom": "timeSigBottom---vP3OE",
	"division": "division---3lT_X",
	"label": "label---2_7Tx",
	"input": "input---1T_FF",
	"divider": "divider---2x2l0"
};